export const mapProfileAvatars = (items) => (Array.isArray(items) ? items : [])
  .map((item) => ({
    id: item.UId,
    posterName: item.Name,
    name: item.Name,
    imageUrl: item.ImageUrl,
    // Only an absent field is a legacy adult avatar. Strings are not booleans.
    isKid: item.isKid === undefined ? false : item.isKid
  }))
  .filter((item) => item.id && item.imageUrl);

export const avatarsForProfile = (avatars, isChild) =>
  avatars.filter((avatar) => avatar.isKid === (isChild === true));

export const sameAvatar = (first, second) =>
  String(first || "").toLowerCase() === String(second || "").toLowerCase();

export const canSaveProfileAvatar = (selected, avatars, isChild, existing) => {
  // Preserve stored choices on unrelated edits, including avatars relabeled by CMS.
  if (existing && !!existing.kid === !!isChild && sameAvatar(selected?.id, existing.avatarUid)) return true;
  return !!selected && avatarsForProfile(avatars, isChild).some((avatar) => sameAvatar(avatar.id, selected.id));
};
